package chat.amp.tim

import de.connect2x.trixnity.messenger.util.RootPath

internal actual fun getDevRootPath(): RootPath? = null
